// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__box--BE0Ez {
  display: flex;
  flex-wrap: wrap;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__separator--_Smdr {
  white-space: pre-wrap;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__newLine--Ci6pr {
  flex-basis: 100%;
  height: 0;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__multiple--xnnB_ {
  width: 100%;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__inline--YUziL {
  display: inline-flex;
  flex-wrap: wrap;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__inline--YUziL:has(.src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__multiple--xnnB_) {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/object/ChildEntitiesLabel/ChildEntitiesLabel.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;AACF;AACA;EACE,qBAAA;AACF;AACA;EACE,gBAAA;EACA,SAAA;AACF;AACA;EACE,WAAA;AACF;AACA;EACE,oBAAA;EACA,eAAA;AACF;AAAE;EACE,WAAA;AAEJ","sourcesContent":[".box {\n  display: flex;\n  flex-wrap: wrap;\n}\n.separator {\n  white-space: pre-wrap;\n}\n.newLine {\n  flex-basis: 100%;\n  height: 0;\n}\n.multiple {\n  width: 100%;\n}\n.inline {\n  display: inline-flex;\n  flex-wrap: wrap;\n  &:has(.multiple) {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__box--BE0Ez`,
	"separator": `src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__separator--_Smdr`,
	"newLine": `src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__newLine--Ci6pr`,
	"multiple": `src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__multiple--xnnB_`,
	"inline": `src-common-attributes-makeAttrLabel-labelMakers-object-ChildEntitiesLabel-ChildEntitiesLabel-module__inline--YUziL`
};
export default ___CSS_LOADER_EXPORT___;
